import * as React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import CircularProgress from '@mui/material/CircularProgress';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Input from '@mui/material/Input';
import InputAdornment from '@mui/material/InputAdornment';
import Camera from '../../assets/profile/profile-camera.png'
import Bag from '../../assets/profile/profile-bag.png'
import Headphones from '../../assets/profile/profile-headphones.png'
import Mobile from '../../assets/profile/profile-mobile.png'
import Laptop from '../../assets/profile/profile-laptop.png'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Tooltip from '@mui/material/Tooltip'; // Import Tooltip from Material-UI
import { API_BASE_URL } from '../../config/apiConfig';
import { headerLogo, submitIcon } from '../../assets/images';

const needListData = [
  { id: '1*' },
  { id: '2*' },
  { id: '3*' },
  { id: 4 },
  { id: 5 },
];

const greedListData = [
  { id: 1 },
  { id: 2 },
  { id: 3 },
  { id: 4 },
  { id: 5 },
];

export function MyLists() {
  const navigate = useNavigate();
  const [needList, setNeedList] = React.useState(needListData);
  const [greedList, setGreedList] = React.useState(greedListData);
  const [isLoading, setIsLoading] = React.useState(false);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);

  const handleNeedListChange = (id, value) => {
    const newList = needList.map(item => {
      if (item.id === id) {
        return { ...item, text: value };
      }
      return item;
    });
    setNeedList(newList);
  };

  const handleGreedListChange = (id, value) => {
    const newList = greedList.map(item => {
      if (item.id === id) {
        return { ...item, text: value };
      }
      return item;
    });
    setGreedList(newList);
  };

  const handleSubmit = async () => {
    const validNeedList = needList.filter(item => item.text);
    const validGreedList = greedList.filter(item => item.text );

    if (validNeedList.length < 3 ) {
      setSnackbarOpen(true);
      return;
    }

    setIsLoading(true);
    const token = sessionStorage.getItem('token');
    let body = {
      needList: validNeedList.map(item => item.text).join(", "),
      greedList: validGreedList.map(item => item.text).join(", ")
    };

    if (token && body) {
      try {
        const response = await fetch(`${API_BASE_URL}/user/update-profile`, {
          method: 'post',
          headers: {
            'Content-Type': 'application/json',
            Authorization: token
          },
          body: JSON.stringify(body)
        });
        const data = await response.json();
        console.log(data);
        navigate("/shippingInfo");
      } catch (error) {
        console.error('Error updating lists', error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  return (
    <MainContainer>
      <ContentWrapper>
        <LeftColumn>
          <LeftColumnContent>
          <div style={{display:'flex',flexDirection:'row',alignItems:'center',gap:'10px'}}>
                    <Logo onClick={() =>  window.open("/", "_blank")} src={headerLogo} alt="Logo" />
                        </div>
                                    <PageTitle>My Lists</PageTitle>
            <PageDescription>
              For curated deals you must list at least 3 purchase requirements.
              You can always come back and fill the rest.
            </PageDescription>
            <StepIndicator>Step 03 / 04
            <Tooltip title="Click here to learn more about us.." arrow>
            <InfoIcon onClick={() => window.open("/about", "_blank")}>
            <InfoOutlinedIcon style={{ width: '16px', height: '16px',backgroundColor:'#e9fe53', borderRadius:'100px'}} />
                                </InfoIcon>
                            </Tooltip>
            </StepIndicator>
            <ProgressBar>
              <ProgressBarFill />
            </ProgressBar>
            <NextStep>Next: Shipping info</NextStep>
          </LeftColumnContent>
        </LeftColumn>
        <RightColumn>
          <RightColumnContent>
            <ListsWrapper>
              <NeedList>
                <ListHeader>
                  <ListTitle>Need List</ListTitle>
                  <ListDescription>
                    I just can't do without these, need to buy them asap.
                  </ListDescription>
                </ListHeader>
                <HorizontalLine />
                <ListInstruction>
                  Products that you are likely to purchase immediately or in the
                  near future. At least 3*
                </ListInstruction>
                <CameraImage src={Camera} alt="Camera" />
                {needList.map((item, index) => (
                    <Input
                      type="text"
                      value={item.text}
                      onChange={(e) => handleNeedListChange(item.id, e.target.value)}
                      startAdornment={
                        <InputAdornment position="start">
                          {item.id}.
                        </InputAdornment>
                      }
                      placeholder={["Headphones", "Mobile Phone", "Backpack", "Watch", "Camera"][index]}
                      style={{ border: '1px solid rgba(32, 32, 35, 1)', height: '80%', width: '80%', marginTop: '8px', padding:'10px' }}
                    />
                ))}
                 <BagImage src={Bag} alt="Bag" />
              </NeedList>
              <GreedList>
                <ListHeader>
                  <ListTitle>Greed List</ListTitle>
                  <ListDescription>
                    Everybody has one, I would like to own one someday
                  </ListDescription>
                </ListHeader>
                <HorizontalLine />
                <ListInstruction>
                  Products you wish to purchase eventually maybe after saving
                  towards it.
                </ListInstruction>
                {greedList.map((item, index) => (
                    <Input
                      type="text"
                      value={item.text}
                      onChange={(e) => handleGreedListChange(item.id, e.target.value)}
                      startAdornment={
                        <InputAdornment position="start">
                          {item.id}.
                        </InputAdornment>
                      }
                      placeholder={["Laptop", "Speakers", "Camera", "Shoes", "iPad"][index]}
                      style={{ border: '1px solid rgba(32, 32, 35, 1)', height: '80%', width: '80%', marginTop: '8px',padding:'10px' }}
                    />
                ))}
                 <HeadphonesImage src={Headphones} alt="Headphones" />
                 <LaptopImage src={Laptop} alt="Laptop" />
                 <MobileImage src={Mobile} alt="Mobile" />
              </GreedList>
            </ListsWrapper>
            <SubmitButton onClick={handleSubmit} disabled={isLoading}>
              {isLoading ? <CircularProgress size={24} /> : <SubmitButtonText>Submit</SubmitButtonText>}
              <SubmitButtonIcon src={submitIcon} alt="Submit" />
            </SubmitButton>
          </RightColumnContent>
        </RightColumn>
      </ContentWrapper>
      <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleCloseSnackbar}>
        <Alert onClose={handleCloseSnackbar} severity="error" sx={{ width: '100%' }}>
          Need list must have at least 3 items to proceed.
        </Alert>
      </Snackbar>
      <FooterWrapper>
        <NavigationLinks>
          <Link onClick={() => window.open("/", "_blank")}>Home</Link>
          <Link onClick={() => window.open("/about", "_blank")}>About Us</Link>
        </NavigationLinks>
        <Copyright>
          Copyright © 2024. SPOELT. All rights reserved
        </Copyright>
      </FooterWrapper>
    </MainContainer>
  );
}
const FooterWrapper = styled.footer`
  display: flex;
  justify-content: space-between;
  align-items: center;
 // padding: 20px;
  @media (max-width: 991px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const MainContainer = styled.main`
  background-color: #fff;
  padding: 39px 80px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
  @media (max-width: 991px) {
    padding: 0 20px;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  gap: 20px;
  @media (max-width: 991px) {
    flex-direction: column;
    align-items: stretch;
    gap: 0;
  }
`;

const LeftColumn = styled.div`
  width: 35%;
  @media (max-width: 991px) {
    width: 100%;
  }
`;

const LeftColumnContent = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 991px) {
    margin-top: 40px;
  }
`;

const Logo = styled.img`
  width: 130px;
  max-width: 100%;
  object-fit: contain;
  cursor: pointer; // Added cursor pointer for logo
`;

const InfoIcon = styled.div`
  width: 10px; // Adjust size as needed
  margin-left: 5px; // Space between text and icon
  cursor: pointer; // Added cursor pointer for info icon
`;

const PageTitle = styled.h1`
  color: #202023;
  margin-top: 129px;
  font: 800 60px/108% Inter, sans-serif;
  @media (max-width: 991px) {
    margin-top: 30px;
    margin-bottom: 10px;
    font-size: 40px;
    line-height: 48px;
  }
`;

const PageDescription = styled.p`
  color: #202023;
  letter-spacing: -0.24px;
  margin-top: 11px;
  font: 400 12px/16px Metrophobic, sans-serif;
`;

const StepIndicator = styled.p`
  display: flex;
  flex-direction: row;
  color: #202023;
  letter-spacing: -0.24px;
  margin-top: 50px;
  padding: 1px 0;
  font: 400 12px/130% Metrophobic, sans-serif;
  @media (max-width: 991px) {
    margin-top: 10px;
  }
`;

const ProgressBar = styled.div`
  border: 1px solid rgba(32, 32, 35, 1);
  display: flex;
  margin-top: 8px;
  padding: 1px 0;
  @media (max-width: 991px) {
    padding-right: 20px;
  }
`;

const ProgressBarFill = styled.div`
  background-color: #e9fe53;
  height: 12px;
  width: 75%;
`;

const NextStep = styled.div`
  color: #202023;
  letter-spacing: -0.24px;
  margin-top: 9px;
  font: 400 12px/130% Metrophobic, sans-serif;
`;

const RightColumn = styled.div`
  margin-left: 40px;
  width: 55%;
  @media (max-width: 991px) {
    width: 100%;
    margin-left: 0;
  }
`;

const RightColumnContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 69px;
  @media (max-width: 991px) {
    margin-top: 40px;
    margin-top: 10px;
  }
`;

const ListsWrapper = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 30px;
  @media (max-width: 991px) {
    flex-direction: column;
    gap: 0;
  }
`;

const NeedList = styled.article`
  width: 50%;
  border: 1px solid rgba(32, 32, 35, 1);
  padding: 33px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #202023;
  position: relative; /* Added for positioning the images */
  @media (max-width: 991px) {
    width: 100%;
    margin-top: 10px;
  }
`;

const GreedList = styled.div`
  width: 50%;
  border: 1px solid rgba(32, 32, 35, 1);
  padding: 33px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #202023;
  position: relative; /* Added for positioning the images */
  @media (max-width: 991px) {
    width: 100%;
    margin-top: 36px;
  }
`;

const ListHeader = styled.div`
  padding: 0 20px;
  @media (max-width: 991px) {
    padding: 0 20px;
  }
`;

const ListTitle = styled.div`
  letter-spacing: -0.48px;
  font: 800 24px/130% Inter, sans-serif;
`;

const ListDescription = styled.p`
  letter-spacing: -0.28px;
  margin-top: 11px;
  font: 400 14px/18px Metrophobic, sans-serif;
`;

const ListImage = styled.img`
  width: 100%;
  border: 1px solid rgba(32, 32, 35, 1);
  margin-top: 21px;
`;

const ListInstruction = styled.p`
  letter-spacing: -0.24px;
  margin-top: 10px;
  margin-left:20px;
  margin-right:20px;
  padding: 0 20px;
  font: 400 12px/16px Metrophobic, sans-serif;
  @media (max-width: 991px) {
    padding: 0 0px
  }
`;

const HorizontalLine = styled.hr`
  width: 100%;
  border: none;
  border-top: 1px solid #000;
  margin: 20px 0;
`;

const ListItem = styled.div`
  border: 1px solid rgba(32, 32, 35, 1);
  border-radius: 1px;
  margin-top: 8px;
  width: 80%;
  max-width: 100%;
  padding: 14px;
  letter-spacing: -0.24px;
  font: 400 12px/130% Metrophobic, sans-serif;
  @media (max-width: 991px) {
    padding-right: 20px;
    white-space: initial;
  }
`;

const SubmitButton = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid rgba(32, 32, 35, 1);
  border-radius: 1px;
  background-color: #e9fe53;
  gap: 8px;
  width: 49%;
  //margin-top: 10px;
  color: #202023;
  white-space: nowrap;
  flex: 1;
  padding: 15px 13px;
  @media (max-width: 991px) {
    padding-right: 20px;
    white-space: initial;
    width: 100%;
    margin-bottom: 20px;
  }
`;

const SubmitButtonText = styled.span`
  font:  16px/130% Metrophobic, sans-serif;
`;

const SubmitButtonIcon = styled.img`
  width: 11px;
  object-fit: contain;
  fill: #202023;
`;

const Copyright = styled.p`
  color: #828282;
  align-self: flex-end;
  font: 400 12px Metrophobic, sans-serif;
  @media (max-width: 991px) {
    align-self: center;
  }
`;

const NavigationLinks = styled.div`
  display: flex;
  justify-content: left;
  gap: 20px;
  margin-top: auto;

  margin-bottom:auto;
  font: 600 22px Metrophobic, sans-serif;
  @media (max-width: 991px) {
    font: 600 16px Metrophobic, sans-serif;
    margin-top: 40px;
    align-self: center;

  }
`;

const Link = styled.span`
  color: #202023;
  cursor: pointer;
`;

const CameraImage = styled.img`
  position: absolute;
  top: 18%; /* Adjust as needed */
  left:-70px;  /* Adjust as needed */
  width: 100px; /* Adjust size as needed */
  z-index: 1; /* Ensure it appears above other elements */
  @media (max-width: 991px) {
    display: none; /* Hide image on mobile view */
  }
`;

const BagImage = styled.img`
  position: absolute;
  bottom: 18%; /* Adjust as needed */
  left: -70px;  /* Adjust as needed */
  width: 100px; /* Adjust size as needed */
  z-index: 1; /* Ensure it appears above other elements */
  @media (max-width: 991px) {
    display: none; /* Hide image on mobile view */
  }
`;

const HeadphonesImage = styled.img`
  position: absolute;
  bottom: 70%; /* Adjust as needed */
  right: -60px; /* Adjust as needed */
  width: 75px; /* Adjust size as needed */
  z-index: 1; /* Ensure it appears above other elements */
  @media (max-width: 991px) {
    display: none; /* Hide image on mobile view */
  }
`;

const LaptopImage = styled.img`
  position: absolute;
  bottom: 45%; /* Adjust as needed */
  right: -60px; /* Adjust as needed */
  width: 100px; /* Adjust size as needed */
  z-index: 1; /* Ensure it appears above other elements */
  @media (max-width: 991px) {
    display: none; /* Hide image on mobile view */
  }
`;

const MobileImage = styled.img`
  position: absolute;
  bottom: 10%; /* Adjust as needed */
  right: -60px; /* Adjust as needed */
  width: 75px; /* Adjust size as needed */
  z-index: 1; /* Ensure it appears above other elements */
  @media (max-width: 991px) {
    display: none; /* Hide image on mobile view */
  }
`;
